import countriesData from "i18n-iso-countries/langs/en.json";

import auStates from "./states/au.json";
import caStates from "./states/ca.json";
import cnStates from "./states/cn.json";
import inStates from "./states/in.json";
import ruStates from "./states/ru.json";
import uaStates from "./states/ua.json";
import usStates from "./states/us.json";

const countries = { ...countriesData.countries, WORLD: "World" };

export default {
  country: countries,
  state: {
    au: auStates,
    ca: caStates,
    cn: cnStates,
    in: inStates,
    ru: ruStates,
    ua: uaStates,
    us: usStates,
  },
};
